export const API_currency_list = () => `/api/v1/currency/list`;
